// extracted by mini-css-extract-plugin
export default {"wrapper":"KB-z","button":"LB-z","alternate":"MB-z","disabled":"NB-z","paymentWarning":"OB-z","fadeIn":"PB-z"};